import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Header from '../../components/Header/Header.js';
import PageTitle from './Sections/PageTitle.js';
import PageTextContent from './Sections/PageTextContent.js';
import Button from '@material-ui/core/Button';
import {getInfoPage} from '../../services/infoPageService';

const styles = theme => ({
    container: {
        textAlign: 'left',
        backgroundColor: '#68246D',
        height: '99vh'
    },
    card: {
        background: 'white',
        margin: '5px',
        height: '95vh',
        overflowY: 'scroll'
    },
    button: {
        textAlign: 'center',
        padding: '10px'
    }
});

class VolunteerPage extends React.Component {
    state = {
        title: '',
        text: '',
        link: ''
    }

    async componentDidMount() {
        const {data: volunteerInfo} = await getInfoPage('volunteer')
        const {text, link, title} = volunteerInfo
        this.setState({
            text, link, title
        })
    }

    render() {
        const {classes} = this.props;
        const {title, text, link} = this.state;
        return (
            <div>
                {/* Header will be essentially the top navbar where the buttons including the donation and volunteer, will go */}
                <Header fixed/>
                {/* A box container for having all the sections inside */}
                <div className={classes.container}>
                    {/* Load the description HTML here i.e. the volunteer description  */}
                    <div className={classes.card}>
                        <PageTitle text={title}/>
                        <PageTextContent text={text}/>
                        <div className={classes.button}>
                            <a href={link}>
                                <Button style={{background: 'rgb(165, 200, 208)'}} variant="contained" color="default">
                                    Volunteer with DREAM
                                </Button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(VolunteerPage);
